import React from 'react';
import { ControlTypeProps } from '../types';
import SingleOrMultiLineText from './singleOrMultiLineText';

const ReadOnlyControl: React.FC<ControlTypeProps> = ({ field, fieldData }) => (
    <SingleOrMultiLineText field={field} fieldData={fieldData} readOnly={true} />
);

export default ReadOnlyControl;
